export default {
  endUserApps: [
    'diruY5f3ekJWM6qhLz6KaVZ2YHJ8ryMa', // (feller-staging) Feller demo app
    'Kueij82P2kb5529OKRmfIuoVwBeNAA1z', // (feller-dev) Sample End user
    'icNTPfBA07o95sou6WpD339EI9B7CY5i', // (feller-staging) Native end user
    'RUKQ6xJhD8sYfl7L3TT5KWLKdlLM7w3N', // (feller-test) End user demo
  ],
  appSignUpDefaultValues: {
    wM3zIUz81cQsrmBBmP7wNmWWZxu6qCH8: { function: 'switch-gear-manufacturer' },
  },
  professionalUserFields: ['phone', 'salutation', 'firstName', 'lastName', 'company', 'function'],
  endUserFields: ['salutation', 'firstName', 'lastName'],
  portalRoles: ['FellerAdmin'],
};
